/**
 * Season-specific display configuration for Midnight Season 1.
 *
 * - HIDDEN_INSTANCE_IDS: instances that don't accept bonus rolls (world
 *   bosses) — filtered out of the loot cache at transform time so neither
 *   the recommendation engine nor the UI ever sees them.
 * - RAID_INSTANCE_ORDER: display order on the Pools page.
 * - BOSS_ORDER: per-instance encounter order (not alphabetical).
 */

export const HIDDEN_INSTANCE_IDS = new Set<number>([
  1312, // "Midnight" — open-world bosses (Lu'ashal, Thorm'belan, Predaxas,
        // Cragpine). Bonus rolls don't apply to world boss kills.
]);

export const RAID_INSTANCE_ORDER: string[] = [
  "The Dreamrift",
  "The Voidspire",
  "March on Quel'Danas",
];

export const BOSS_ORDER: Record<string, string[]> = {
  "The Dreamrift": [
    "Chimaerus the Undreamt God",
  ],
  "The Voidspire": [
    "Imperator Averzian",
    "Vorasius",
    "Fallen-King Salhadaar",
    "Vaelgor & Ezzorak",
    "Lightblinded Vanguard",
    "Crown of the Cosmos",
  ],
  "March on Quel'Danas": [
    "Belo'ren, Child of Al'ar",
    "Midnight Falls",
  ],
};

export function isHiddenInstance(instanceID: number): boolean {
  return HIDDEN_INSTANCE_IDS.has(instanceID);
}

/** Lower number = earlier in the Pools-page list. Unknown raids fall last. */
export function raidInstanceRank(name: string): number {
  const i = RAID_INSTANCE_ORDER.indexOf(name);
  return i < 0 ? Number.MAX_SAFE_INTEGER : i;
}

/** Boss order within a raid instance. Unknown bosses fall last alphabetically. */
export function bossRank(instanceName: string, bossName: string | undefined): number {
  if (!bossName) return Number.MAX_SAFE_INTEGER;
  const order = BOSS_ORDER[instanceName];
  if (!order) return Number.MAX_SAFE_INTEGER;
  const i = order.indexOf(bossName);
  return i < 0 ? Number.MAX_SAFE_INTEGER : i;
}
